<div class="payments-container line">
  <div class="payments-container-label">
    {{ 'webPos.Voucher.MaxAmountsToRefund' | translate }}
  </div>
  <div class="payments-info" *ngIf="showGift">
    <div class="payments-info-block">
      <span>{{ 'webPos.Voucher.GiftCertificate' | translate }}</span>
    </div>
    <div class="payments-info-block payments-info-block--amount">
      <span class="payments-info--bold">{{ maxGift | hcurrency }}</span>
    </div>
  </div>
  <div class="payments-info">
    <div class="payments-info-block">
      <span>{{ 'webPos.Voucher.BenefitCertificate' | translate }}</span>
    </div>
    <div class="payments-info-block payments-info-block--amount">
      <span class="payments-info--bold">{{ maxBenefit | hcurrency }}</span>
    </div>
  </div>
</div>
